const stickyCart = document.querySelector('[data-view-cart-sticky]');
const stickyCount = document.querySelector('[data-view-cart-count]');
const stickyMedia = document.querySelector('[data-view-cart-media]');

if (stickyCart && stickyCount) {
  const openCartDrawer = () => {
    const selectors = [
      'cart-drawer-component',
      'cart-drawer',
      '[data-cart-drawer]',
      'details-modal[id*="cart"]'
    ];

    for (const selector of selectors) {
      const el = document.querySelector(selector);
      if (!el) continue;

      if (typeof el.open === 'function') {
        el.open();
        return true;
      }

      if (typeof el.show === 'function') {
        el.show();
        return true;
      }

      if ('open' in el) {
        el.open = true;
        return true;
      }

      el.setAttribute('open', '');
      el.classList.add('active', 'is-open');
      return true;
    }

    const toggle = document.querySelector('[aria-controls*="cart"], [href*="/cart"], [data-cart-toggle]');
    if (toggle instanceof HTMLElement && toggle !== stickyCart) {
      toggle.click();
      return true;
    }

    return false;
  };

  const setVisible = (visible) => {
    stickyCart.hidden = false;
    stickyCart.classList.toggle('view-cart-sticky--visible', visible);
  };

  const renderImages = (items) => {
    if (!stickyMedia) return;

    const lastThree = [...items]
      .slice()
      .reverse()
      .filter((item) => item.image)
      .slice(0, 3);

    stickyMedia.innerHTML = lastThree
      .map((item) => {
        const src = String(item.image)
          .replace(/\.(jpg|jpeg|png|webp)(\?.*)?$/i, '_80x80_crop_center$&');
        const alt = (item.product_title || item.title || 'Product').replace(/"/g, '&quot;');
        return `<img class="view-cart-sticky__thumb" src="${src}" alt="${alt}" loading="lazy" width="28" height="28">`;
      })
      .join('');
  };

  const updateFromCart = (cart) => {
    const count = Number(cart?.item_count) || 0;
    stickyCount.textContent = String(count);

    if (count <= 0) {
      renderImages([]);
      setVisible(false);
      return;
    }

    renderImages(cart.items || []);
    setVisible(true);
  };

  const fetchCart = async () => {
    try {
      const response = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      if (!response.ok) return null;
      return await response.json();
    } catch (error) {
      console.warn('Sticky cart fetch failed:', error);
      return null;
    }
  };

  let syncTimeout = null;

  const fetchAndSyncCart = async () => {
    const cart = await fetchCart();
    if (cart) updateFromCart(cart);
  };

  const scheduleFetchAndSyncCart = () => {
    if (syncTimeout) window.clearTimeout(syncTimeout);
    syncTimeout = window.setTimeout(() => {
      syncTimeout = null;
      fetchAndSyncCart();
    }, 60);
  };

  stickyCart.addEventListener('click', (event) => {
    if (openCartDrawer()) {
      event.preventDefault();
    }
  });

  window.addEventListener('pageshow', scheduleFetchAndSyncCart);

  document.addEventListener('cart:update', async (event) => {
    const cart = event.detail?.data?.cart;
    if (cart) {
      updateFromCart(cart);
    } else {
      scheduleFetchAndSyncCart();
    }
  });

  document.addEventListener('DOMContentLoaded', scheduleFetchAndSyncCart);
  scheduleFetchAndSyncCart();
}
